import { Flex, Text } from '@televet/kibble-ui';
import React, { FC, useMemo } from 'react';
import { FeatureFlagName } from 'shared/enums';
import { ottoLabsClinicSettingsMap } from '../constants/index';
import OttoLabsClinicSetting from './OttoLabsClinicSetting';

type OttoLabsClinicSettingsListProps = {
  flags?: FeatureFlagName[];
};

const OttoLabsClinicSettingsList: FC<OttoLabsClinicSettingsListProps> = ({ flags }) => {
  const validFlags = useMemo(() => (flags || []).filter((flag) => !!ottoLabsClinicSettingsMap[flag]), [flags]);

  if (!validFlags?.length) {
    return <></>;
  }

  return (
    <>
      <Flex margin="10px 0" alignItems="center">
        <Text size="xl">Clinic Settings</Text>
      </Flex>
      <Flex mb="24px">These will affect all members of your clinic.</Flex>
      {validFlags.map((flag, index) => (
        <Flex key={flag} mb={index < validFlags.length ? '16px' : '0'}>
          <OttoLabsClinicSetting flag={flag} />
        </Flex>
      ))}
    </>
  );
};

export default OttoLabsClinicSettingsList;
